
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "id": "图层_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "x": "0px",
    "y": "0px",
    "viewBox": "0 0 200 200",
    "style": "enable-background:new 0 0 200 200;",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "class": "st0",
        "d": "M100,30.1c-0.5,0-1,0.1-1.5,0.2l-55,12.9c-2.9,0.7-4.9,3.2-5,6.1v62.2c0,32,53,55.2,59,57.7\n\tc0.8,0.3,1.7,0.5,2.5,0.5c0.9,0,1.7-0.2,2.5-0.5c10-4.3,19.6-9.6,28.6-15.7c20.1-13.8,30.3-27.9,30.3-42.1V81.4l-0.3-0.8l-0.2-0.4\n\tl-0.4-0.6l-0.4-0.4l-0.4-0.5l-0.4-0.3l-0.6-0.4l-0.6-0.3l-0.7-0.3l-0.5-0.2l-0.7-0.2h-2.5L100,89l-27.7-6.2c-3.4-1-7,1-8,4.4\n\tc0,0,0,0,0,0c-1,3.4,1,7,4.5,8l0.7,0.2l29.1,6.5c0.4,0.1,0.9,0.2,1.4,0.2c0.5,0,0.9,0,1.4-0.2l47.1-10.6v20.4\n\tc0,18.8-32.9,37.6-48.5,44.7c-15.6-7.1-48.5-25.8-48.5-44.7V54.5L100,43.1l53.5,12.8c0.5,0.1,1,0.2,1.5,0.2c3.6,0,6.5-2.9,6.5-6.5\n\tc0-3-2.1-5.6-5-6.3l-55-12.9C101,30.2,100.5,30.1,100,30.1"
      }
    }
  ]
})
    }
  